import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from '@devsigner-com/observer-sdk';

import App from './App';

observer.init({
  endpoint: 'https://api.monitor.koro.com.br/observer',
  batchInterval: 5000,
  maxQueueSize: 200,
  captureRequestBody: true,
  captureResponseBody: true,
  captureHeaders: true,
  includeUrls: [/\.koro\.com\.br/],
  name: `Koro Admin (${process.env.REACT_APP_BRANCH})`,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
